class Anchor

  defOpts =
    duration: 600
    easing  : 'easeOutQuad'
    offset  : 0

  constructor: (el, opts = {}) ->
    { @duration, @easing, @offset } = _.defaults opts, defOpts

    @$trigger = $ el
      .not '.js-noscroll'
      .on 'click', @onClicked

  scroll: (el, $trigger, opts = {}) ->
    unless @duration or @easing or @offset
      { @duration, @easing, @offset } = _.defaults opts, defOpts
    $ el
      .velocity 'stop'
      .velocity 'scroll',
        duration: @duration
        easing  : @easing
        offset  : @offset
        begin   : ->
          $trigger.trigger 'beforeScroll.anchor'
        complete: ->
          $trigger.trigger 'afterScroll.anchor'

  onClicked: (e) =>
    $elm       = $ e.currentTarget
    href       = $elm.attr 'href'
    targetLink = $elm.prop 'href'
    targetHash = $elm.data 'hash'
    nowHash    = location.hash
    nowHref    = location.href.replace nowHash, ''
    unless href.indexOf('#') is 0
      if targetLink is nowHref
        href = targetHash
      else
        $elm.attr 'href', targetLink + targetHash
        return true

    return if href.length is 0
    e.preventDefault()
    el =
      if href is '#' then 'html, body' else href
    @scroll el, @$trigger

export default Anchor



// WEBPACK FOOTER //
// ./webpack/imports/view/anchor.coffee